export enum IUserRole {
    ReadOnly = "Read Only",
    Owner = "Owner",
    Resident = "Resident",
    Tenant = "Tenant",
    ShortTermTenant = "Short Term Tenant",
}
